import { Link } from '@amzn/awsui-components-core';
import React from 'react';

interface Props {
  text: string;
  href: string;
}

const CustomizedLink = (props: Props) => {
  return (
    <Link variant="secondary" href={props.href} target="_blank" rel="noopener noreferrer">
      {props.text}
    </Link>
  );
};

export default CustomizedLink;
